const TFA_LOCK_COOKIE_NAME = "2falock";

export const getTfaLockCookieName = (userId?: number | null): string | null => {
  if (!Number.isInteger(userId) || userId <= 0) {
    return null;
  }

  return `${TFA_LOCK_COOKIE_NAME}:${userId}`;
};

export const getTfaLockCookieValue = (
  cookies: Record<string, unknown>,
  userId?: number | null,
): string | null => {
  const cookieName = getTfaLockCookieName(userId);
  if (!cookieName) {
    return null;
  }

  const value = cookies[cookieName];
  if (typeof value === "string") {
    return value;
  }

  return null;
};
